import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNavigationStore = defineStore('navigation', () => {
  const navigationPosition = ref(0);
  const userType = ref('main');

  const setNavigationPosition = (value) => {
    navigationPosition.value = value;
  };
  const setUserType = (value) => {
    userType.value = value;
  };

  return { 
    navigationPosition, 
    setNavigationPosition,
    userType,
    setUserType
   };
});
